var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFigma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 50,
    viewBox: "0 0 35 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.17318 50C11.3833 50 13.5029 49.122 15.0657 47.5592C16.6285 45.9964 17.5065 43.8768 17.5065 41.6667V33.3333H9.17318C6.96304 33.3333 4.84342 34.2113 3.28062 35.7741C1.71782 37.3369 0.839844 39.4565 0.839844 41.6667C0.839844 43.8768 1.71782 45.9964 3.28062 47.5592C4.84342 49.122 6.96304 50 9.17318 50Z",
    fill: "#0ACF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.839844 25C0.839844 22.7899 1.71782 20.6703 3.28062 19.1075C4.84342 17.5447 6.96304 16.6667 9.17318 16.6667H17.5065V33.3334H9.17318C6.96304 33.3334 4.84342 32.4554 3.28062 30.8926C1.71782 29.3298 0.839844 27.2102 0.839844 25Z",
    fill: "#A259FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.839844 8.33333C0.839843 6.12432 1.71692 4.00569 3.27832 2.44308C4.83971 0.880461 6.95766 0.00172579 9.16667 0L17.5 0V16.6667H9.17318C6.96304 16.6667 4.84342 15.7887 3.28062 14.2259C1.71782 12.6631 0.839844 10.5435 0.839844 8.33333Z",
    fill: "#F24E1E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5066 0H25.8399C28.0501 0 30.1697 0.877974 31.7325 2.44078C33.2953 4.00358 34.1733 6.1232 34.1733 8.33333C34.1733 10.5435 33.2953 12.6631 31.7325 14.2259C30.1697 15.7887 28.0501 16.6667 25.8399 16.6667H17.5066V0Z",
    fill: "#FF7262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1733 25C34.1733 27.2102 33.2953 29.3298 31.7325 30.8926C30.1697 32.4554 28.0501 33.3334 25.8399 33.3334C23.6298 33.3334 21.5102 32.4554 19.9474 30.8926C18.3846 29.3298 17.5066 27.2102 17.5066 25C17.5066 22.7899 18.3846 20.6703 19.9474 19.1075C21.5102 17.5447 23.6298 16.6667 25.8399 16.6667C28.0501 16.6667 30.1697 17.5447 31.7325 19.1075C33.2953 20.6703 34.1733 22.7899 34.1733 25Z",
    fill: "#1ABCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33.5106,
    height: 50,
    fill: "white",
    transform: "translate(0.744629)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigma);
export default __webpack_public_path__ + "static/media/figma.4a483f9526920eedbbee9eaccc66a48b.svg";
export { ForwardRef as ReactComponent };